// companyActions.js
export const INIT_COMPANY_LIST_REQUEST = 'INIT_COMPANY_LIST_REQUEST';
export const SET_COMPANY_LIST = 'SET_COMPANY_LIST'; // use to set company list data
export const ERROR_COMPANY_LIST = 'ERROR_COMPANY_LIST'; // use for all types of errors
export const ERROR_COMPANY = 'ERROR_COMPANY'; // use for all type of error (edit, update and view)
export const SET_COMPANY = 'SET_COMPANY'; // use for single company
export const ADD_COMPANY = 'ADD_COMPANY'; // use to add new company
export const UPDATE_COMPANY = 'UPDATE_COMPANY'; // use to update company
export const DELETE_COMPANY = 'DELETE_COMPANY'

export function initCompanyListRequest() {
  return { type: INIT_COMPANY_LIST_REQUEST };
}

export function setCompanyList(data) {
  return { type: SET_COMPANY_LIST, payload: data };
}

export function errorCompanyList(error) {
  return { type: ERROR_COMPANY_LIST, payload: error };
}

export function errorComapny(data) {
  return { type: ERROR_COMPANY, payload: data };
}

export function addCompany(company) {
  return { type: ADD_COMPANY, payload: company };
}

export function updateCompany(company) {
  return { type: UPDATE_COMPANY, payload: company };
}

export function setCompany(data) {
  return { type: SET_COMPANY, payload: data };
}

export function deleteCompany(data) {
  return { type: DELETE_COMPANY, payload: data };
}